import React from 'react';
export function ProductPresentation() {
  return <section className="bg-chocolate-900 text-chocolate-50 py-24 px-4 overflow-hidden relative" data-id="element-221">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-222"></div>

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-223">
        <p className="text-gold-400 font-bold tracking-widest uppercase mb-4" data-id="element-224">
          Presentamos
        </p>
        <h2 className="text-4xl md:text-6xl font-bold mb-12 leading-tight" data-id="element-225">
          MÉTODO ANTÍDOTO DULCE
          <br data-id="element-226" />
          <span className="text-gold-500" data-id="element-227">SISTEMA COMPLETO</span>
        </h2>

        <div className="flex justify-center mb-12" data-id="element-228">
          <img src="https://cdn.magicpatterns.com/uploads/wryWuUseiTipAJwCNbcZvi/Mockup.png" alt="Sistema Completo Método Antídoto Dulce" className="w-full max-w-2xl drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-229" />
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-230">
          <p className="text-xl md:text-2xl font-medium leading-relaxed mb-4" data-id="element-231">
            El primer sistema de nutrición diseñado para la mujer argentina que
            no quiere dejar de comer dulce.
          </p>
          <p className="text-gold-400 text-lg md:text-xl font-bold" data-id="element-232">
            500+ páginas de entrenamiento nutricional.
          </p>
        </div>
      </div>
    </section>;
}